export default "<div class=\"height_adjst\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n";